module.exports = __webpack_public_path__ + "img/AI.93db1f66.png";